import { PaymentAction } from 'adyen-web-new';

import {
  ICheckoutAwaitAction,
  ICheckoutQrCodeAction,
  ICheckoutRedirectAction,
  ICheckoutTreeDsTwoAction,
  ICheckoutVoucherAction,
} from '@model';

import { TAdyenAction } from '../model';

const prepareThreeDS2 = (action: ICheckoutTreeDsTwoAction): PaymentAction => ({
  ...action,
  authorisationToken: action.authorisationToken ?? '',
  paymentData: action.paymentData ?? '',
  paymentMethodType: action.paymentMethodType ?? '',
  subtype: action.subtype ?? '',
  token: action.token ?? '',
  url: action.url ?? '',
});

const prepareRedirect = (action: ICheckoutRedirectAction): PaymentAction => ({
  ...action,
  method: action.method ?? '',
  paymentMethodType: action.paymentMethodType ?? '',
  url: action.url ?? '',
});

const prepareAwait = (action: ICheckoutAwaitAction): PaymentAction => ({
  ...action,
  paymentData: action.paymentData ?? '',
  paymentMethodType: action.paymentMethodType ?? '',
  url: action.url ?? '',
});

const prepareVoucher = (action: ICheckoutVoucherAction): PaymentAction => ({
  ...action,
  alternativeReference: action.alternativeReference ?? '',
  downloadUrl: action.downloadUrl ?? '',
  entity: action.entity ?? '',
  expiresAt: action.expiresAt ?? '',
  instructionsUrl: action.instructionsUrl ?? '',
  issuer: action.issuer ?? '',
  maskedTelephoneNumber: action.maskedTelephoneNumber ?? '',
  merchantName: action.merchantName ?? '',
  merchantReference: action.merchantReference ?? '',
  paymentData: action.paymentData ?? '',
  paymentMethodType: action.paymentMethodType ?? '',
  reference: action.reference ?? '',
  shopperEmail: action.shopperEmail ?? '',
  shopperName: action.shopperName ?? '',
  url: action.url ?? '',
});

const prepareQrCode = (action: ICheckoutQrCodeAction): PaymentAction => ({
  ...action,
  type: action.type ?? '',
  paymentData: action.paymentData ?? '',
  paymentMethodType: action.paymentMethodType ?? '',
  url: action.url ?? '',
  expiresAt: action.expiresAt ?? '',
  qrCodeData: action.qrCodeData ?? '',
});

export const mapAdyenActionFromDomain = (action: TAdyenAction): PaymentAction | null => {
  switch (action.type) {
    case 'threeDS2':
      return prepareThreeDS2(action);
    case 'redirect':
      return prepareRedirect(action);
    case 'await':
      return prepareAwait(action);
    case 'voucher':
      return prepareVoucher(action);
    case 'qrCode':
      return prepareQrCode(action);
    default:
      return null;
  }
};
